// extracted by mini-css-extract-plugin
export default {"container":"styles_container__i32bg","spin":"styles_spin__9J1Nt"};